import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [3, 4, 5],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
❯❯ Welcome to manzan.dev
    </Text>
    <Text sx={{
      fontSize: [1, 2, 3]
    }} mdxType="Text">
      <br />
I enjoy crafting pragmatic, beautiful & effective software solutions that people love using.
      <br />
My guiding principle is <i>«build the simplest thing that could possibly work, then iterate»</i>.
      <br />
Welcome to my corner of the web.
      <br />
      <br />
    </Text>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      